// extracted by mini-css-extract-plugin
export default {"button":"DoubleCheckButton_button__+ti3w"};